import { EditOutlined } from "@mui/icons-material";
import { Box, Button, Chip, Typography } from "@mui/material";
import DataSectionComponent from "../view/DataSectionComponent";
import ViewTestDataCSS from "../view/ViewTestData.module.css";

interface ViewTestDataProps {
  isDefault: Boolean;
  initialTestData: Map<string, Map<string, Map<string, any>>>;
  testDataFileName: string;
  entityType: string;
  mappedFeatureList: string[];
  handleOnViewBack: () => void;
  handleOnEdit: (isViewToEdit: boolean) => void;
}

const ViewTestData = ({
  isDefault,
  testDataFileName,
  initialTestData,
  entityType,
  mappedFeatureList,
  handleOnViewBack,
  handleOnEdit,
}: ViewTestDataProps) => {
  const parsedTestData =
    typeof initialTestData === "string"
      ? JSON.parse(initialTestData)
      : initialTestData;

  const jsonObject: Record<string, any> = {
    name: entityType,
    data: parsedTestData,
  };

  return (
    <Box>
      <Box className={ViewTestDataCSS.outerHeaderBox}>
        <Box sx={{ display: "inline" }}>
          <Box
            className={ViewTestDataCSS.innerHeaderBox}
            sx={{ margin: "1rem 0rem" }}
          >
            <Typography
              variant="body2"
              className={ViewTestDataCSS.headerName}
              sx={{ whiteSpace: "nowrap" }}
            >
              Test Data File Name
            </Typography>
            <Typography sx={{ whiteSpace: "nowrap" }}>
              {testDataFileName}
            </Typography>
          </Box>
          {!isDefault && (
            <Box className={ViewTestDataCSS.innerHeaderBox}>
              <Typography
                variant="body2"
                className={ViewTestDataCSS.headerName}
                sx={{ whiteSpace: "nowrap" }}
              >
                Entity Type
              </Typography>
              <Typography sx={{ whiteSpace: "nowrap" }}>
                {entityType}
              </Typography>
            </Box>
          )}
        </Box>
        {!isDefault && (
          <Box className={ViewTestDataCSS.featureInnerHeaderBox}>
            <Typography
              variant="body2"
              sx={{ whiteSpace: "nowrap", fontWeight: 600 }}
            >
              Feature File Map
            </Typography>
            <Box className={ViewTestDataCSS.featureFileList}>
              {mappedFeatureList.length !== 0 ? (
                mappedFeatureList.map((value: string) => (
                  <Chip
                    sx={{ padding: "10px" }}
                    key={value}
                    label={value}
                    onMouseDown={(e) => e.stopPropagation()}
                  />
                ))
              ) : (
                <span style={{ color: "#aaa" }}> Feature Files</span>
              )}
            </Box>
          </Box>
        )}
      </Box>
      <Box>
        <DataSectionComponent jsonObject={jsonObject.data} />
      </Box>
      <Box className={ViewTestDataCSS.actionBox}>
        {!isDefault && (
          <Button
            variant="outlined"
            startIcon={<EditOutlined />}
            onClick={() => handleOnEdit(true)}
          >
            Edit
          </Button>
        )}
        <Button
          variant="outlined"
          onClick={handleOnViewBack}
        >
          Back
        </Button>
      </Box>
    </Box>
  );
};

export default ViewTestData;
